export const textFieldTypes = {
  NUMBER: 'number',
  TEXT: 'text'
}
